import cn from 'classnames';
import type { FC, ReactNode } from 'react';
import React from 'react';

import { Icon } from '@sravni/react-design-system/lib/Icon';
import { Space } from '@sravni/react-design-system/lib/Space';
import { Text } from '@sravni/react-design-system/lib/Typography';
import { Tip } from '@sravni/react-icons';

import type { FILTERS_NAMES } from '@src/constants/filters';
import { UNBREAKABLE_SEPARATOR } from '@src/constants/unbreakableSeparator';
import { ServiceBannerInfoSheet } from 'entities/ServiceBanner/ui/ServiceBannerInfoSheet';
import { FullDealEntryPointForm } from 'features/FullDeal';

import { useCalculator } from '../../../../lib';
import type { RenderActionsProps } from '../../../../types';

import cardsCoinsImage from './assets/cardsCoins.png';
import { FullDealEntryPointBannerForGoogle } from './FullDealEntryPointBannerForGoogle';
import styles from './FullDealEntryPointForGoogle.module.scss';
import { FullDealGoogleOfferActions } from './FullDealGoogleOfferActions/FullDealGoogleOfferActions';

interface Props {
  isLanding?: boolean;
  highlightOffer?: boolean;

  onChange?: (key: FILTERS_NAMES, value: number) => void;
  renderActions?: (props: RenderActionsProps) => ReactNode;
}

export const FullDealEntryPointForGoogle: FC<Props> = ({
  highlightOffer = true,
  onChange,
  renderActions,
  isLanding,
}) => {
  const { amount, term, handleChange, isInfoShown, setIsInfoShown, isShowCalculator, hasOffer, toFullDealButtonText } =
    useCalculator(onChange);

  return (
    <div className={cn(styles.relativeContainer)}>
      {highlightOffer && (
        <Space size={8} align="center" className={styles.header}>
          <Text strong className={styles.headerText}>
            Сравни{UNBREAKABLE_SEPARATOR}— Сервис №1 по займам
          </Text>
          <Icon size={16} icon={<Tip />} className={styles.headerIcon} onClick={setIsInfoShown.on} />
        </Space>
      )}
      <ServiceBannerInfoSheet visible={isInfoShown} onClose={setIsInfoShown.off} />

      <div className={styles.container}>
        <div className={styles.content}>
          <FullDealEntryPointBannerForGoogle
            isLanding={isLanding}
            mobileBanner={
              <img src={cardsCoinsImage} alt="" className={styles.mobileIllustration} width={170} height={95} />
            }
          />

          <div className={styles.calculatorRow}>
            {isShowCalculator && (
              <div className={styles.formWrapper}>
                <FullDealEntryPointForm amount={amount} term={term} onChange={handleChange} className={styles.form} />
              </div>
            )}

            <div className={styles.actions}>
              {!renderActions && <FullDealGoogleOfferActions amount={amount} term={term} isLandingPage={isLanding} />}

              {renderActions?.({
                amount,
                term,
                hasOffer,
                toFullDealButtonText,
              })}
            </div>
          </div>
        </div>

        <div className={cn('mobile:hidden', styles.illustration)}>
          <img src={cardsCoinsImage} alt="" className={styles.illustrationImg} width={304} height={224} />
        </div>
      </div>
    </div>
  );
};
